<template>
  <div>
    <div class="sec-banner">
      <img src="../../assets/banner.jpg" alt="为亿万家庭主食安全服务" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'sec-banner',
  props: {
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/assembly/sec-banner.vue